import { render, staticRenderFns } from "./ParentAdvertMgmt.vue?vue&type=template&id=2344e648"
import script from "./ParentAdvertMgmt.vue?vue&type=script&lang=js"
export * from "./ParentAdvertMgmt.vue?vue&type=script&lang=js"
import style0 from "./ParentAdvertMgmt.vue?vue&type=style&index=0&id=2344e648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports